export default {
    org: "dfCapital",
    orgColors: {
        primary: "#3aaf61",
        secondary: "#1f4e79",
        tertiary: "#F99D25",
        dark: "#1f4e79",
        medium: "#babfc3",
        light: "#fff"
    },
    palette: {
        background: {
            default: "#fff"
        },
        error: {
            main: "#ee315e"
        },
        primary: {
            main: "#3aaf61"
        },
        secondary: {
            main: "#1f4e79"
        },
        tertiary: {
            main: "#F99D25"
        },
        common: {
            white: "#fff"
        },
        default: {
            main: "#1f4e79"
        }
    },
    typography: {
        fontFamily: ["Cabin", "sans-serif"].join(",")
    },
    components: {
        MuiButton: {
            styleOverrides: {
                /** Theming structure */
                containedDefault: {
                    background: "#1f4e79",
                    color: "#F99D25"
                },
                containedPrimary: {
                    color: "#fff"
                },
                outlinedPrimary: {
                    color: "#3aaf61"
                },
                containedSecondary: {
                    color: "#fff"
                },
                outlinedSecondary: {
                    color: "#1f4e79"
                },
                containedError: {
                    background: "#ee315e",
                    color: "#fff"
                },
                outlinedError: {
                    color: "#ee315e"
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                /** Theming structure */
                root: {}
            }
        },
        MuiDataGrid: {
            styleOverrides: {
                columnHeaders: {
                    color: "#3aaf61",
                    "&  svg": {
                        color: "#3aaf61"
                    }
                },
                footerContainer: {
                    "& svg": {
                        color: "#3aaf61"
                    }
                }
            }
        }
    },
    overrides: {},
    shape: {
        borderRadius: 1
    }
};
